<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-5 col-md-7 ml-auto mr-auto">
              <info-section class="mt-5"
                            type="danger"
                            title=""
                            description=""
                            icon="nc-icon nc-alert-circle-i">
                <h2 class="text-white mt-3">{{$t('views.404.title')}}</h2>
                <small class="text-white">{{$t('views.404.description')}}
                  <br>
                  {{$t('views.404.navigateBack')}} <router-link to="/">{{$t('views.404.linkBacktoHomePage')}}</router-link>
                </small>
              </info-section>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-size: cover;height: 100%;width: 100%;position: fixed;top: 0;background-image: url(/static/img/background/jan-sendereks.jpg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  /* Card, */ Checkbox, Button, InfoSection
} from 'src/components/UIComponents'
import AppNavbar from '../Dashboard/Views/Pages/Layout/AppNavbar'
import AppFooter from '../Dashboard/Views/Pages/Layout/AppFooter'

export default {
  components: {
    // Card,
    AppNavbar,
    AppFooter,
    InfoSection,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  methods: {
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    }
  },
  beforeDestroy () {
    this.closeMenu()
  }
}
</script>
<style>
</style>
